export default {
  statusPublished () {
    if (this.rule.published) {
      return 'Publicado'
    }

    return 'Aguardando publicação'
  },
  allowPublish () {
    return (this.rule.id && !this.rule.published)
  },
  allPreview () {
    return (this.rule.id && !this.rule.preview)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/computed.js